import React from 'react';

import useIsUpMD from 'hooks/media_query/useIsUpMD';

import CompressedButton from './CompressedButton';
import Buttons from './Buttons';

const AuthenticationButtons = ({
  showCompressed = false,
  justify = 'center',
}) => {
  const isUpMD = useIsUpMD();

  if (!showCompressed) return <Buttons justify={justify}></Buttons>;

  return isUpMD ? (
    <Buttons justify={justify}></Buttons>
  ) : (
    <CompressedButton></CompressedButton>
  );
};

export default AuthenticationButtons;
